export default __webpack_public_path__ + "images/hpi.f7e9ea96.webp";